<div class="form-element">
  <label class="label" [for]="inputId">
    {{ label }}
    <span *ngIf="!required" class="optional">({{ 'LABEL.OPTIONAL' | translate }})</span>
  </label>
  <div class="input">
    <ng-content></ng-content>
  </div>
  <div *ngIf="description" class="description">{{ description }}</div>
  <mat-error *ngIf="errors.length > 0" class="errors">{{ errors[0] }}</mat-error>
</div>
